export default "__VITE_ASSET__qVjKfC2h__"